__turbopack_context__.v({
  "appLinksBlock": "_HFjoW_appLinksBlock",
  "award": "_HFjoW_award",
  "awards": "_HFjoW_awards",
  "awardsSkiAward": "_HFjoW_awardsSkiAward",
  "downloadBadge": "_HFjoW_downloadBadge",
  "footerBottomContent": "_HFjoW_footerBottomContent",
  "logo": "_HFjoW_logo",
  "socialIcon": "_HFjoW_socialIcon",
  "socialsBlockHeader": "_HFjoW_socialsBlockHeader",
  "socialsBlockList": "_HFjoW_socialsBlockList",
  "wrapper": "_HFjoW_wrapper",
});
